package one.healthium.promo_banner.ui

data class PromoBannerUiState(
    val bannerData: PromoBannerData? = null
)
